import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    // NOTE: this is only temporary so we could sync up login session of old API server and the lambda's redis
    // TODO: please remove this once we are fully migrated to lambda functions
  }

}
